<template>
    <div></div>
</template>

<script>

export default {
    props: ['btn']
}    
</script>